export default class FileUtils {
    static downloadFile(
        base64: string,
        fileName: string,
        mimeType: string = "application/pdf"
    ) {
        const link = document.createElement("a");
        // create a blobURI pointing to our Blob
        link.href = `data:${mimeType};base64,${base64}`;
        link.download = fileName;
        // some browser needs the anchor to be in the doc
        document.body.append(link);
        link.click();
        link.remove();
        // in case the Blob uses a lot of memory
        setTimeout(() => URL.revokeObjectURL(link.href), 7000);
    }

    /**
     * Télécharge un blob (réponse binaire d'un endpoint protégé par JWT) sous
     * le nom de fichier donné.
     */
    static downloadBlob(blob: Blob, fileName: string) {
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = fileName;
        // some browser needs the anchor to be in the doc
        document.body.append(link);
        link.click();
        link.remove();
        // in case the Blob uses a lot of memory
        setTimeout(() => URL.revokeObjectURL(link.href), 7000);
    }
}
